export default __webpack_public_path__ + "static/h2-v4-advent-calendar-bc80663e744607bc8492b3d41e2854ba.svg";